<template>
	<section ref="qrPanel" class="qr-section">
		<client-only>
			<div class="qr-panel">
				<div class="row">
					<form class="booking bookForm">
						<div class="columns column4">
							<date-picker
								v-model:value="state.arrival"
								:clearable="false"
								:disabled-date="disableArrivalDates"
								format="DD-MM-YYYY"
								:placeholder="$t('checkIn')"
								:lang="datepickerLang"
								@pick="pickArrival"
							/>
						</div>
						<div class="columns column4">
							<date-picker
								v-model:value="state.departure"
								:open="state.openDeparture"
								:disabled-date="disableDepartureDates"
								format="DD-MM-YYYY"
								:placeholder="$t('checkOut')"
								:lang="datepickerLang"
								:default-value="state.pickArrivalDate ?? new Date()"
								@open="state.openDeparture = true"
								@close="state.openDeparture = false"
							/>
						</div>
						<div class="columns column4">
							<book-button
								:arrival="state.arrival"
								:departure="state.departure"
								class="button book-now cta qr"
							>
								{{ bookingForm.availability }}
							</book-button>
						</div>
					</form>
				</div>
				<div class="row">
					<div class="columns column12">
						<span>
							{{ bookingForm.benefitsContent }}
						</span>
						<span v-for="benefit in bookingForm.benefit" :key="benefit.ID">
							<font-awesome-icon :icon="`fa fa-check`" size="1x" />
							{{ benefit.content }}
						</span>
					</div>
				</div>
			</div>
		</client-only>
	</section>
</template>

<script setup>
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';
import datePickerTranslations from '~/i18n/datePicker.ts';

const { locale } = useI18n();

defineProps({
	bookingForm: { type: Object, default: () => ({}) },
});

const state = reactive({
	arrival: null,
	departure: null,
	openDeparture: false,
	pickArrivalDate: null,
});

const qrPanel = ref(null);

const datepickerLang = computed(() => datePickerTranslations[locale] ?? datePickerTranslations.en);

const pickArrival = (date) => {
	state.departure = null;
	state.pickArrivalDate = date;
	state.openDeparture = true;
};

const disableArrivalDates = (date) => {
	const today = new Date();

	return date < today.setDate(today.getDate() - 1);
};

const disableDepartureDates = (date) => {
	if (!state.pickArrivalDate) {
		return disableArrivalDates(date);
	}

	return date <= state.pickArrivalDate;
};

onMounted(() => {
	qrPanel.value.classList.add('mounted');
});
</script>

<style>
.qr-panel .mx-datepicker {
	width: 100%;
}

.qr-panel .mx-icon-calendar {
	right: 18px !important;
}

.qr-panel .mx-input {
	margin: 3px 0 !important;
	width: 100% !important;
	padding: 15px 40px 15px 18px !important;
	letter-spacing: 1px;
	height: 46px !important;
	border: none !important;
	border-radius: 0 !important;
	text-transform: uppercase;
}
</style>

<style lang="scss" scoped>
.qr-section {
	text-align: center;
	margin: 0 auto;
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 0;
	float: left;
	width: 100%;
	z-index: 10;
}

.qr-panel {
	float: none;
	padding: 0;
	width: 100%;
	margin: 0 auto;
	display: inline-block;
	position: relative;
	z-index: 2;
	text-align: center;

	.row {
		width: 100%;
		background: rgb(244 242 236 / 35%);
		backdrop-filter: blur(14px);
		padding: 3px 10px;
		max-width: 100vw;

		form,
		.column12 {
			margin: 0 auto;
			max-width: 900px;
			text-align: center;
		}

		&:last-child {
			background: #fbf9f6;
			padding: 6px 25px;
			font-size: 14px;

			span {
				margin: 0 12px;
				color: #000;
			}

			svg {
				margin: 0 5px;
			}
		}
	}

	.columns {
		padding: 10px;
	}

	form {
		width: 100%;
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		justify-content: space-between;
	}
}

.qr-panel input,
.qr-panel select {
	margin: 3px 0 !important;
	width: 100% !important;
	padding: 15px 40px 15px 18px !important;
	height: 46px !important;
	border: none !important;
	border-radius: 0 !important;
}

.qr-panel .button {
	padding: 15px 20px;
	text-transform: uppercase;
	border: none;
	vertical-align: top;
}
</style>
